import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LoadListFields, SaveListFields as _SaveListFields } from '@/api/ListParam';
import { mapGetters } from 'vuex';
export default {
  name: 'BaseColumn',
  data: function data() {
    return {
      columnVisible: false,
      columnList: [],
      columnSlect: []
    };
  },
  computed: _objectSpread({}, mapGetters(['userinfo'])),
  methods: {
    // 全部显示
    handleAllSubmitSave: function handleAllSubmitSave() {
      if (this.columnList.length === this.columnSlect.length) {
        return this.$message({
          message: '当前配置列已全部加载',
          type: 'warning'
        });
      } else {
        this.columnList.map(function (item) {
          if (item.IS_VISIBLE === 'N') item.IS_VISIBLE = 'Y';
        });
      }

      this.SaveListFields(this.columnList);
    },
    // 确认保存
    handleSubmitSave: function handleSubmitSave() {
      var _this = this;

      var columnList = this.columnList || [];
      var flagKeys = [];
      columnList.forEach(function (item) {
        return flagKeys.push(item.FIELD_NAME);
      });
      var indexSearch = [];
      flagKeys.map(function (item) {
        indexSearch.push(_this.columnSlect.indexOf(item));
      });
      indexSearch.forEach(function (item, index) {
        if (item === -1) {
          columnList[index].IS_VISIBLE = 'N';
        } else {
          columnList[index].IS_VISIBLE = 'Y';
        }
      });
      console.log(columnList);
      this.SaveListFields(columnList);
    },

    /**
     * @name: 保存
     * @param {*} data
     * @return {*}
     */
    SaveListFields: function SaveListFields(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loading, res, collectColumn, collectColumns;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this2.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context.next = 3;
                return _SaveListFields(data).catch(function (_) {
                  loading.close();
                });

              case 3:
                res = _context.sent;
                loading.close();

                if (res.Result) {
                  _this2.columnVisible = false;

                  _this2.$notify({
                    title: '成功',
                    message: '保存成功',
                    type: 'success'
                  }); // 判断列是否隐藏


                  collectColumn = _this2.$parent.$refs.xTable.collectColumn; // 过滤

                  collectColumns = collectColumn.filter(function (i) {
                    return i.property;
                  });
                  collectColumns && collectColumns.map(function (item, index) {
                    if (data[index] && data[index].FIELD_NAME) {
                      if (data[index].FIELD_NAME === item.property) {
                        item.visible = data[index].IS_VISIBLE === 'Y';
                      }
                    }
                  });

                  _this2.$emit('SeniorColumn', res.Result);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 总配置列
    handleColumnTableLoad: function handleColumnTableLoad() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return LoadListFields({
                  USER_NAME: _this3.userinfo.USER_NAME
                });

              case 2:
                res = _context2.sent;

                if (res.Result) {
                  _this3.columnList = res.Result;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleSearchTableLoad: function handleSearchTableLoad() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var flag, event, tempData, collectColumn, bodyHeight, bodyWidth, doubleBody, $event;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                flag = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                event = _arguments.length > 1 ? _arguments[1] : undefined;

                if (!flag) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 5;
                return _this4.handleColumnTableLoad();

              case 5:
                if (!(_this4.columnList.length <= 0)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", _this4.$message({
                  message: '暂无表格列信息配置',
                  type: 'warning'
                }));

              case 7:
                // 当前显示列
                tempData = [];
                collectColumn = _this4.$parent.$refs.xTable.collectColumn;
                collectColumn.map(function (item) {
                  if (item.visible) {
                    tempData.push(item.property);
                  }
                });
                _this4.columnSlect = tempData;

              case 11:
                bodyHeight = document.body.offsetHeight;
                bodyWidth = document.body.offsetWidth;
                doubleBody = document.querySelector('.doubleCode .el-dialog');

                if (event) {
                  $event = event.$event;
                  doubleBody.style.left = $event.clientX - 100 + 'px';

                  if (bodyHeight - $event.clientY <= 200) {
                    doubleBody.style.top = $event.clientY - 150 + 'px';
                  } else {
                    doubleBody.style.top = $event.clientY + 30 + 'px';
                  }

                  if (bodyWidth - $event.clientX <= 200) {
                    doubleBody.style.left = $event.clientX - 300 + 'px';
                  }
                }

                _this4.columnVisible = flag;

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};